import { toEDNStringFromSimpleObject } from "edn-data";
import { queryOmegaSingleResult } from "../api";
import { Cron } from "../types/cron";
import { CronBlock } from "../types/notebook/note/block/cron";

export interface CronInput {
  "page-id": string;
  name: string;
  schedule: string;
  "subscription-page-id": string;
  "subscription-name": string;
}

const cronQuery = async <T,>(term: string, input: object): Promise<T> => {
  const ednString = toEDNStringFromSimpleObject(input as any, { keysAs: "string" });
  const query = `
(datastore Qo.Public.Api.Cron "omega/query-omega/public/api/cron")
(= Input ${ednString})
(${term} Input Result)
(return [Result])
`;
  return queryOmegaSingleResult(query);
};

export const upsertCron = (input: CronInput): Promise<CronBlock> =>
  cronQuery("Qo.Public.Api.Cron/upsert", input);

export const getCronStatus = (input: {
  "page-id": string;
  name: string;
}): Promise<Cron> => cronQuery("Qo.Public.Api.Cron/status", input);

export const getCronStatusById = (input: {
  "app-id": string;
  "cron-id": string;
}): Promise<Cron> => cronQuery("Qo.Public.Api.Cron/status-by-id", input);

export const deleteCron = (input: {
  "page-id": string;
  name: string;
}): Promise<{ deleted: string }> => cronQuery("Qo.Public.Api.Cron/remove", input);
